<template>
	<div class="score">
		<div class="score__bar">
			<div class="score__filler" :style="style"/>
			<p class="score__text">{{Math.round(usedPercentage)}} / 100</p>
		</div>
		<div style="clear: both"/>
	</div>
</template>

<script>
export default {
    props: ["percentage"],

    data() {
        return {
            usedPercentage: 0
        };
    },

    mounted() {
        this.usedPercentage = 0;

        let p = this.percentage;
        setTimeout(() => {
            this.usedPercentage = p;
        }, 200);
    },

    watch: {
        percentage: function(val) {
            this.usedPercentage = val;
        }
    },

    computed: {
        style() {
            let percentage = this.usedPercentage + "%";
            let offset = 100 - this.usedPercentage + "%";
            return { width: percentage };
        }
    },

    methods: {}
};
</script>


// WEBPACK FOOTER //
// src/components/Score.vue